import {createContext, useContext, useState} from 'react';
import useUser from '../../../../hooks/data/user/useUser';
import useUserSavedPartners from '../../../../hooks/data/user/useUserSavedPartners';
import useUserPartnerOperations from '../../../../hooks/data/user/useUserPartnerOperations';

const UserContext = createContext();

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    console.error('useUserContext: the component from which you are trying to use this context must be a ContextProviderNavigation component descendant.');
  }
  return context;
}

export default function ContextProviderUser({children}) {
  const [refetchUserSavedPartners, setRefetchUserSavedPartners] = useState(true);

  const {
    user,
    isLoggedInUserFetchingInProgress,
    loggedInUserFetchingError
  } = useUser();


  const {
    isUserSavedPartnersFetchingInProgress,
    userSavedPartnersFetchingError,
    userSavedPartnerSiteIds,
    userSavedPartners,
    //userSavedPartnerCount
  } = useUserSavedPartners(user, refetchUserSavedPartners, setRefetchUserSavedPartners);

  const {
    isUserPartnerOperationInProgress,
    saveUserPartner,
    removeUserPartner
  } = useUserPartnerOperations();

  return (
    <UserContext.Provider value={
      {
        user,
        isLoggedInUserFetchingInProgress,
        loggedInUserFetchingError,
        refetchUserSavedPartners,
        setRefetchUserSavedPartners,
        isUserSavedPartnersFetchingInProgress,
        userSavedPartnersFetchingError,
        userSavedPartnerSiteIds,
        userSavedPartners,
        //userSavedPartnerCount,

        isUserPartnerOperationInProgress,
        saveUserPartner,
        removeUserPartner


      }
    }>{children}</UserContext.Provider>
  );
}
